import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "aside" }
const _hoisted_2 = { class: "aside__content" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "aside__list" }
const _hoisted_5 = { class: "aside__footer" }
const _hoisted_6 = { class: "aside__footer-list" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: `${_ctx.config.publicPath}${_ctx.imagePath}`
      }, null, 8, _hoisted_3),
      _createElementVNode("h2", null, [
        _renderSlot(_ctx.$slots, "title")
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("ul", _hoisted_4, [
          _renderSlot(_ctx.$slots, "list")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("ul", _hoisted_6, [
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            href: _ctx.config.supportUrl,
            target: "_blank"
          }, "Support", 8, _hoisted_7)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            href: _ctx.config.faqUrl,
            target: "_blank"
          }, "FAQ", 8, _hoisted_8)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            href: _ctx.config.privacyPolicyUrl,
            target: "_blank"
          }, " Privacy Policy ", 8, _hoisted_9)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            href: _ctx.config.tosUrl,
            target: "_blank"
          }, "Terms of Use", 8, _hoisted_10)
        ])
      ])
    ])
  ]))
}